<template>
  <v-form v-model="valid" ref="mainForm">
    <CaseACocherLive
      code="sans_emploi"
      v-model="sas.sasInscriptionTableau.sansEmploi"
      :live="{ endpoint: 'sas-inscription-tableau', cle: 7709, fileId: sas.sasInscriptionTableau.id }"
      :opqIf="sas.sasAdressesProfessionnelles.filter((e) => !e.inactif).length === 0"
    />
    <data-iterator
      :list="sas.sasAdressesProfessionnelles"
      add-new-text="Ajouter un lieu d'exercice"
      :live="{ endpoint: 'sas-adresses', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
      hidePoints
      :optional="sas.sasInscriptionTableau.sansEmploi"
    >
      <template v-slot:show-mode="{ item }">
        <OrganisationCardContent v-if="item" :organisation="item" />
      </template>
      <template v-slot:edit-mode="{ item }">
        <SearchOrganisation v-if="!item.organisationId" @organisation-selected="organisationSelected(item, $event)"></SearchOrganisation>
        <OrganisationCardContent :organisation="item" />
        <v-checkbox
          class="list_counter_validator my-2 ml-6 p-0"
          :input-value="!!item.organisationId"
          :rules="[(v) => !!v || 'Veuillez sélectionner une organisation']"
        ></v-checkbox>
      </template>
    </data-iterator>
    <CatalogueLive
      ref="proPrincipal"
      code="pro_principal"
      :items="sas.sasAdressesProfessionnelles?.map(getTextSasAdresseDropdown)"
      v-model="sas.sasInscriptionTableau.lieuDeTravailPrincipal"
      :live="{ endpoint: 'sas-inscription-tableau', cle: 7711, fileId: sas.sasInscriptionTableau.id }"
      :opqIf="!sas.sasInscriptionTableau.sansEmploi"
    />
    <DomicileProfessionnel :sas="sas" />
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import RelationSasAdresse from "@/mixins/RelationSasAdresse"
import SearchOrganisation from "@/components/Common/SearchOrganisation.vue"
import OrganisationCardContent from "@/components/Common/OrganisationCardContent.vue"
import DomicileProfessionnel from "@/components/form_parts/DomicileProfessionnel.vue"

import { Queue, Api } from "@/plugins/api"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, RelationSasAdresse],
  components: { SearchOrganisation, OrganisationCardContent, DomicileProfessionnel },
  props: {
    sas: { type: Object }
  },
  computed: {},
  watch: {
    // Si on supprime l'adresse pro principale sélectionnée dans le catalogue, on force le reset pour ne pas conserver une référence vide.
    "sas.sasAdressesProfessionnelles.length"() {
      const principal = this.sas.sasInscriptionTableau.lieuDeTravailPrincipal
      if (principal && !this.sas.sasAdressesProfessionnelles?.some((a) => a.id == principal)) {
        this.$refs.proPrincipal?.clear()
      }
    }
  },
  methods: {
    organisationSelected(item, org) {
      Queue.enqueue(() =>
        Api.post("sas-adresses", {
          fileId: item.id,
          cle: "300",
          value: org.organisationId
        }).then(() => {
          this.sas.sasAdressesProfessionnelles.splice(this.sas.sasAdressesProfessionnelles.indexOf(item), 1, { ...org, id: item.id })
        })
      )
    }
  }
}
</script>

<style>
</style>